import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantFaqItem } from '../../../shared/services/tenant.service';

const DEFAULT_TENANT_FAQS: TenantFaqItem[] = [
  {
    question: 'What happens if I miss a live class?',
    answer:
      'Every live session is recorded in HD and uploaded to your student dashboard within 24 hours. You can rewatch lessons anytime throughout your enrollment.',
  },
  {
    question: 'How do I receive study materials and tutes?',
    answer:
      'Comprehensive PDF study guides and tutes are available for instant download in your student portal. Printed study packs are dispatched where applicable.',
  },
  {
    question: 'Can I ask questions and clear doubts during class?',
    answer:
      'Yes! Live Zoom sessions feature interactive audio and chat Q&A. Enrolled students also gain access to dedicated community groups for ongoing support.',
  },
  {
    question: 'What payment methods are supported?',
    answer:
      'You can pay securely online using Visa, Mastercard, or direct bank transfer deposit slip upload.',
  },
];

const DEFAULT_PLATFORM_FAQS: TenantFaqItem[] = [
  {
    question: 'Is the platform live and accessible?',
    answer:
      'Yes! Our platform is fully live. Students can sign up, view the schedule of upcoming live Zoom classes, enroll in subject streams, and access study materials right from their dashboard.',
  },
  {
    question: 'How do live Zoom classes work on the platform?',
    answer:
      'Once enrolled in a class, you will see direct single-click "Join Class" buttons in your dashboard. You can attend live Zoom lectures with real-time video, audio, and interactive Q&A.',
  },
  {
    question: 'What if I miss a live class?',
    answer:
      "Don't worry! Class recordings are automatically uploaded to your learning dashboard after each live session. You can rewatch lessons anytime at your own convenience.",
  },
  {
    question: 'Which subjects and levels are offered?',
    answer:
      'We cover G.C.E. Advanced Level (A/L Science, Maths, Commerce, Tech, Arts), G.C.E. Ordinary Level (O/L Local 9 core subjects), as well as International Edexcel and Cambridge syllabus units.',
  },
  {
    question: 'How can I register as a teacher or tutor?',
    answer:
      'If you are an educator, you can visit our "Teach" page or select "Instructor" during account registration to submit your tutor profile and start hosting live classes.',
  },
];

@Component({
  selector: 'black-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class FaqSectionComponent {
  @Input() customFaqs?: TenantFaqItem[];
  @Input() isDefaultTenant = true;
  @Input() supportEmail?: string;
  @Input() theme: 'modern' | 'warm' | 'bold' = 'modern';

  get hasCustomFaqs(): boolean {
    return Array.isArray(this.customFaqs) && this.customFaqs.length > 0;
  }

  get activeFaqs(): TenantFaqItem[] {
    if (this.hasCustomFaqs) {
      return this.customFaqs!;
    }
    if (this.isDefaultTenant) {
      return DEFAULT_PLATFORM_FAQS;
    }
    return DEFAULT_TENANT_FAQS;
  }

  get contactEmail(): string {
    return this.supportEmail || (this.isDefaultTenant ? 'support@learnbird.lk' : '');
  }
}
